export const getState = (state) => state;
export const getBoard = (state) => state.board;
export const getSettings = (state) => state.settings;